import { html } from '@shared/utils/rendering/html';
import Form from '@shared/components/forms';

import { useRef, useMemo } from 'preact/hooks';

import { RatingsFromId } from '../../../../../../constants/chips/ratings.constants';
import { useViewEvidenceFormSchema } from '@core/configs/forms/subcomponents/subcomponent-form.schema';
import { useFormConfig } from '@core/utils/forms';
import { viewEvidenceFormOptions } from '@core/configs/forms/subcomponents/subcomponent-form.config';

const ViewEvidenceForm = ({ rowData, ...props }) => {
    const schema = useViewEvidenceFormSchema();
    const config = useFormConfig(); // to be used soon.

    const formRef = useRef(undefined);

    const formData = useMemo(() => {
        if (!rowData) return {};

        const ratingObject = RatingsFromId(rowData?.ratingId);
        return {
            comment: rowData?.comment || 'No comment provided',
            rating: ratingObject ? [ratingObject] : [],
            uploadEvidence: rowData?.evidence || null,
        };
    }, [rowData]);

    return html`
        <div class="card-header"><h4>View Evidence</h4></div>
        <div class="card-body">
            <${Form}
                ref=${formRef}
                schema=${schema}
                onSubmit=${() => {}}
                initialValues=${formData}
                options=${{
                    ...viewEvidenceFormOptions,
                }}
            />
        </div>
    `;
};

export default ViewEvidenceForm;
